"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ApiLoadingComponent;

require("core-js/modules/es.object.assign.js");

var _react = _interopRequireDefault(require("react"));

var _Spinner = _interopRequireDefault(require("react-bootstrap/Spinner"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ApiLoadingComponent(props) {
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "loading-component",
    className: "svb-loading-component"
  }, /*#__PURE__*/_react.default.createElement(_Spinner.default, _extends({
    animation: props.animation || 'border'
  }, props), props.children));
}